var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "89A86B97-FB8F-44E6-ACC0-0FB259BD2BC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.539999962
  }, /*#__PURE__*/React.createElement("g", {
    id: "dealer-central-Dashboard",
    transform: "translate(-918.000000, -1022.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(0.000000, 1004.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone",
    transform: "translate(918.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8511716,14.3977331 C16.2374163,13.3304765 13.5285694,11.1338061 12.6335478,11.1338061 C12.572035,11.1338061 12.5153244,11.1428144 12.4645592,11.1603806 C12.0440317,11.3072156 11.7934073,11.5869229 11.572739,11.8328491 C11.3694497,12.0598579 11.1773653,12.2735794 10.8553954,12.3823545 L10.8183505,12.3884351 C10.339969,12.3884351 9.05071704,11.375003 8.16507092,10.3027918 C7.56343525,9.57447191 7.44452589,9.17608049 7.46922245,9.05581988 C7.58378705,8.73422409 7.80102532,8.5452753 8.03106921,8.34529136 C8.28169357,8.12751606 8.56524668,7.88068904 8.71434073,7.46698353 C8.75458698,7.35505559 8.87738377,7.0145424 7.97435859,5.75495889 C7.17766583,4.64356168 5.67209029,3 4.9707537,3 C4.88637378,3 4.81022605,3.01981823 4.74413988,3.05855386 C3.73158088,3.65760484 3.15395576,4.47848485 3.02704288,5.49844796 C2.68334907,8.26038827 5.70501904,11.5637265 7.01988224,12.8564155 C8.22269623,14.0383025 11.3125104,16.7883069 14.0195279,16.7883069 L14.0202139,16.7883069 C15.2637315,16.7883069 16.2461058,16.2106506 16.9403536,15.0702016 C17.0931064,14.8190957 16.9113123,14.502004 16.8511716,14.3977331",
    id: "Fill-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0190ba105c35171c511f033c8dde93cd.svg";
export { ForwardRef as ReactComponent };